import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface LayoutState {
    footerVisible: boolean;
    mapLoaded: boolean;
    enterFormVisible: boolean;
    enterFormMessage: string | null;
    registrationFormVisible: boolean;
    isSoonVisible: boolean;
    restorePassFormVisible: boolean;
    changePassFormVisible: boolean;
    enterByEmailVisible: boolean;
    emailEnterForm: boolean;
    finishRegistrationFormVisible: boolean;
    hideFinishRegForm: boolean;
    enterCodeFormVisible: boolean;
    technicalPause?: boolean;
    callbackFormVisible?: boolean;
    supportFormVisible: boolean;
    compareFormVisible: boolean;
    bannerUploadVisible: boolean;
    findVinVisible: boolean;
    drawerVisible: boolean;
    paymentIframeVisible: boolean;
    balanceConfirmVisible: boolean;
}

const initialState = {
    technicalPause: process.env.NEXT_PUBLIC_TECHNICAL_PAUSE === "true",
    footerVisible: true,
    enterFormVisible: false,
    enterFormMessage: null,
    registrationFormVisible: false,
    isSoonVisible: false,
    changePassFormVisible: true,
    enterByEmailVisible: false,
    emailEnterForm: false,
    finishRegistrationFormVisible: false,
    enterCodeFormVisible: false,
    callbackFormVisible: false,
    supportFormVisible: false,
    hideFinishRegForm: false,
    compareFormVisible: false,
    bannerUploadVisible: false,
    findVinVisible: false,
    drawerVisible: false,
    paymentIframeVisible: false,
    balanceConfirmVisible: false
} as LayoutState;

export const modalsNames = [
    "enterFormVisible",
    "registrationFormVisible",
    "restorePassFormVisible",
    "changePassFormVisible",
    "enterByEmailVisible",
    "emailEnterForm",
    "finishRegistrationFormVisible",
    "enterCodeFormVisible",
    "callbackFormVisible",
    "supportFormVisible",
    "compareFormVisible",
    "bannerUploadVisible",
    "findVinVisible",
    "balanceConfirmVisible"
];

const hideModalsMethod = (state: LayoutState, except?: string) => {
    for (let modalName of modalsNames) {
        // @ts-ignore
        if (modalName !== except && state[modalName]) {
            // @ts-ignore
            state[modalName] = false;
        }
    }
};

const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        disableFooter(state) {
            state.footerVisible = false;
        },
        enableFooter(state) {
            state.footerVisible = true;
        },
        mapLoaded(state) {
            state.mapLoaded = true;
        },
        showEnterForm(state, action: PayloadAction<string | undefined>) {
            hideModalsMethod(state);
            
            
            state.enterByEmailVisible = true;
            state.enterFormMessage = action.payload ?? null;
        },
        hideEnterForm(state) {
            state.enterFormVisible = false;
            state.enterFormMessage = null;
        },
        showRegistrationForm(state) {
            hideModalsMethod(state);

            state.registrationFormVisible = true;
        },
        showEnterByEmail(state) {
            hideModalsMethod(state);
            state.enterByEmailVisible = true;
        },
        showCallbackForm(state) {
            hideModalsMethod(state);
            state.callbackFormVisible = true;
        },
        showCompareForm(state) {
            hideModalsMethod(state);
            state.compareFormVisible = true;
        },
        showSupportForm(state) {
            hideModalsMethod(state);
            state.supportFormVisible = true;
        },
        hideRegistrationForm(state) {
            state.registrationFormVisible = false;
        },
        setIsSoonVisible(state, action: PayloadAction<boolean>) {
            state.isSoonVisible = action.payload;
        },
        showRestorePassForm(state) {
            hideModalsMethod(state);
            state.restorePassFormVisible = true;
        },
        hideRestorePassForm(state) {
            state.restorePassFormVisible = false;
        },
        showChangePassFormVisible(state) {
            state.changePassFormVisible = true;
        },
        showEnterByEmailVisible(state) {
            hideModalsMethod(state);
            state.emailEnterForm = true;
        },
        hideChangePassFormVisible(state) {
            state.changePassFormVisible = false;
        },
        hideModals(state, action: PayloadAction<string | undefined>) {
            hideModalsMethod(state, action.payload);
        },
        hideFinishRegForm(state) {
            state.hideFinishRegForm = true;
        },
        showFinishRegistrationForm(state) {
            if (state.hideFinishRegForm === true) {
                return;
            }
            hideModalsMethod(state);
            state.finishRegistrationFormVisible = true;
        },
        showEnterCodeForm(state) {
            hideModalsMethod(state);
            state.enterCodeFormVisible = true;
        },
        showBannerUpload(state) {
            hideModalsMethod(state);
            state.bannerUploadVisible = true;
        },
        showFindVinModal(state) {
            hideModalsMethod(state);
            state.findVinVisible = true;
        },
        showBalanceReportModal(state) {
            hideModalsMethod(state);
            state.balanceConfirmVisible = true;
        },
        showDrawer(state) {
            state.drawerVisible = true;
        },
        hideDrawer(state) {
            state.drawerVisible = false;
        },
        showPaymentIframe(state) {
            hideModalsMethod(state);
            state.paymentIframeVisible = true;
        },
        hidePaymentIframe(state) {
            state.paymentIframeVisible = false;
        }
    }
});

export const {
    disableFooter,
    enableFooter,
    mapLoaded,
    showEnterForm,
    hideEnterForm,
    showRegistrationForm,
    hideRegistrationForm,
    setIsSoonVisible,
    showRestorePassForm,
    hideRestorePassForm,
    hideChangePassFormVisible,
    hideModals,
    showEnterByEmail,
    showEnterByEmailVisible,
    showFinishRegistrationForm,
    hideFinishRegForm,
    showEnterCodeForm,
    showCallbackForm,
    showSupportForm,
    showCompareForm,
    showBannerUpload,
    showFindVinModal,
    showBalanceReportModal,
    showDrawer,
    hideDrawer,
    showPaymentIframe,
    hidePaymentIframe
} = layoutSlice.actions;
export default layoutSlice;